<template>    
    <section class="section section-shaped section-lg min-h-screen flex items-center justify-center">
        <div class="max-w-screen-sm md:w-1/3">
            <div class="card shadow-sm rounded-3xl mx-4">

                <div class="flex flex-row-reverse">
                <router-link to="/auth/login" class="go-back">
                    <Close class="text-dark"/>
                </router-link>
                <div class="logo"></div>
                </div>

                <div class="card-body px-lg-5 pt-lg-5">
                <form @submit.prevent="update">

                    <CustomInput
                    identity="email"
                    ref="email"
                    label="Correo electrónico"
                    placeholder="Correo electrónico"
                    disabled
                    v-model="email"
                    :rules="{
                        required: true,
                        email: true,
                    }"
                    />
                    <CustomInput
                    identity="password"
                    ref="password"
                    label="Nuevo Password"
                    placeholder="Nuevo Password"
                
                    type="password"
                    v-model="password"
                    :rules="{
                        required: true
                    }"
                    />

                    <div class="text-center">
                    <span v-if="!loginButton">
                        <button type="submit" class="btn-recover my-4">
                        Cambiar
                        </button>
                    </span>
                    <span v-else>
                        <button
                        class="btn btn-recover my-4"
                        style="width: 95px"
                        disabled
                        >
                        <div class="row">
                            &nbsp;&nbsp;
                            <half-circle-spinner
                            :animation-duration="600"
                            :size="17"
                            color="#ffffff"
                            style="margin-left: 25%;padding-top: 2px;"
                            />&nbsp;
                        </div>
                        </button>
                    </span>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import toastr from 'toastr'
    import axios from 'axios'
    import {HalfCircleSpinner} from 'epic-spinners'
    import CustomInput from "../../../v2/src/components/CustomInput.vue";
    import Close from "../../../v2/src/components/icons/Close.vue";
    export default {
        name: 'ResetPasswordConfirm',
        components: {
            HalfCircleSpinner,
            Close,
            CustomInput
        },
        data(){
            return {
                email: this.$route.params.email,
                token:this.$route.params.token,
                loginButton:false,
                password:'',
            }
        },
        created(){

        },
        methods: {
            update:function () {
                this.loginButton = true;

                var url_tk = '/oauth/token';
                axios.post(url_tk, {
                    grant_type: 'client_credentials',
                    client_secret: process.env.VUE_APP_CLIENT_AP,
                   client_id: process.env.VUE_APP_CLIENT_ID
                }).then(response => {
                    var url = '/api/v1/resetPassConfirm';
                    var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;

                    /* this.disab =  true;*/
                    axios.post(url, {
                        headers:{
                            token
                        },
                        email: this.email,
                        token: this.token,
                        password:this.password,
                    }).then(response => {
                        this.loginButton = false;
                        this.password = '';
                        toastr.success('Datos actualizados con éxito!');
                        this.$router.push('/auth/login');
                    }).catch(err => {
                        console.log(err);
                        this.loginButton = false;
                        toastr.error('un error a ocurrido intente nuevamente o contacte a soporte@cambiandotusalud.com!');
                    });
                });

            },
        },

    }
</script>
<style scoped>
section {
  background-image: url(/image/resource/11_fondo_png.jpg);
  background-size: cover;
  background-position: center;
}

.go-back {
  position: relative;
  color: #fff;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  /* background: linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 5px 6px #00000029; */
}
.go-back> svg{
    margin-top: 7px;
    margin-left: 7px;
}

button {
  outline: none !important;
}

.input-group {
  border-radius: 0 !important;
}

.logo {
  width: 110px;
  height: 38px;
  background-size: contain;
  background-image: url(/image/brand/logo.png);
  margin: 0 auto;
  margin-top: 14px;
  background-repeat: no-repeat;
}

.btn-recover {
  background: transparent linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  opacity: 1;
  color: #ffffff;
  font-size: 23px;
  width: 80%;
  height: 52px;
  max-width: 284px;
  margin: 0 auto;
}

.input-group-alternative {
  box-shadow: none !important;
  border: 0.5px solid #a7a7a7;
}

.input-group-prepend {
  margin-right: 0 !important;
}
</style>
